export default __webpack_public_path__ + "static/media/sandglass.7b40dd22.png";